// Fluency / speed (Phase 5) — pure helpers for the optional Speed Run repeated-reading
// round. We have NO speech recognition by design, so "speed" is the tap-through pace over
// a known line: a WCPM PROXY, not true oral reading rate. The self-calibrating "beat your
// own best" comparison is the real motivator; the absolute target is gentle and tuned at
// play-test. Never punitive — slow just fills the charge bar less.

/** Words-per-minute proxy: tapping `words` words in `ms` milliseconds. */
export function wpm(words: number, ms: number): number {
  if (ms <= 0 || words <= 0) return 0;
  return words / (ms / 60000);
}

/** Gentle target pace at which the web-shooter charge bar reads "full" (proxy; tune at
 *  play-test). Tap-pace runs faster than true oral reading, so this is generous. */
export const TARGET_WPM = 90;

/** Charge-bar fill 0..1 for a pace, against the gentle target. */
export function chargeFill(w: number): number {
  if (w <= 0) return 0;
  return Math.max(0, Math.min(1, w / TARGET_WPM));
}

/** Did this run beat his previous best (lower ms = faster)? A first-ever run is not
 *  "improved" (there's nothing to beat) — the UI shows a fresh-record message instead. */
export function improved(prevBestMs: number | undefined, ms: number): boolean {
  return prevBestMs !== undefined && ms < prevBestMs;
}
